<template>
  <a-card :bordered="false" title="用户数据" :headStyle="{fontSize:'18px'}">
    <div><span class="side">用户实时数据 </span> 更新时间:{{ now }}</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>登录用户数</span>
          <p>{{ todayData.loginNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新增用户数</span>
          <p>{{ todayData.newMemberNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>下单用户数</span>
          <p>{{ todayData.memberOrderNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>收藏商品用户数</span>
          <p>{{ todayData.memberFavoriteNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>累计用户数</span>
          <p>{{ todayData.memberTotalNumber }}</p></div>
      </a-col>
    </a-row>
    <div>
      <span class="side">用户概览数据数据</span>
      <span class="right-title">
      <a-button :class="{ isActive:isChange === 1}" style="border:0;" @click="getDays(1)">昨日</a-button>
      <a-button :class="{ isActive:isChange === 7}" style="border:0;" @click="getDays(7)">近7天</a-button>
      <a-button :class="{ isActive:isChange === 30}" style="border:0;" @click="getDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDate"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="value"
          style="margin-right:12px;"
          :mode="mode"
          @calendarChange="handlePanelChange"
          @change="handleChange"
          @openChange="openChange"
        />
      </span>
    </span>
    </div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>登录用户数</span>
          <p>{{ overviewData.loginNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新增用户数</span>
          <p>{{ overviewData.newMemberNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>下单用户数</span>
          <p>{{ overviewData.memberOrderNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>收藏商品用户数</span>
          <p>{{ overviewData.memberFavoriteNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>累计用户数</span>
          <p>{{ overviewData.memberTotalNumber }}</p></div>
      </a-col>
    </a-row>
    <a-row>
      <div class="line-title">{{ titleHeader }}登录用户数</div>
      <div id="v-container" v-if='showChart'>
        <v-chart :forceFit="true" :height="500" :data="lineData" :padding="padding">
          <v-legend :position="position"></v-legend>
          <v-tooltip crosshairs="y"></v-tooltip>
          <v-axis :tickCount="8"></v-axis>
          <v-line position="date*value" color="type"></v-line>
        </v-chart>
      </div>
    </a-row>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UsersData',
  data() {
    return {
      titleHeader: '昨日',
      isChange: 1,
      now: '',
      todayData: {
        loginNumber: 0,
        newMemberNumber: 0,
        memberOrderNumber: 0,
        memberFavoriteNumber: 0,
        memberTotalNumber: 0
      },
      overviewData: {
        loginNumber: 0,
        newMemberNumber: 0,
        memberOrderNumber: 0,
        memberFavoriteNumber: 0,
        memberTotalNumber: 0
      },
      lineData: [],
      todayTime: '',
      yesterdayTime: '',
      endTime: '',
      startTime: '',
      mode: ['date', 'date'],
      value: [],
      startValue: '',
      position: 'top-right',
      showChart: false,
      padding: [40, 0, 80, 50]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showChart = true
      this.today()
      this.getDays(1)
    })
  },
  methods: {
    handleChange(value) {
      this.value = value
    },
    handlePanelChange(value) {
      this.startValue = value[0]._d
      this.getLogUtils().logWithTag('this.startValue', this.startValue)
      if (value[0] && value[1]) {
        this.startTime = moment(value[0]._d).format('YYYY-MM-DD')
        this.endTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.isChange = -1
        this.titleHeader = ''
        this.getMemberOverviewData()
        this.getLogUtils().logWithTag('this.endValue', this.endValue)
      }
    },
    //禁选开始时间前后31天
    disabledDate(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startValue).getTime() - 8.64e7 * 31
    },
    //日期选择框关闭回调
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    //获取今天日期
    today() {
      var now = moment().subtract('days', 0).format('YYYY-MM-DD HH:mm:ss ')
      var today = moment().subtract('days', 0).format('YYYY-MM-DD')
      this.todayTime = today
      this.now = now
      this.getMemberRealTime()
      this.getLogUtils().logWithTag('今天时间', this.todayTime)
    },
    //获取昨日、近7天、近30天日期
    getDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.startTime = startTime
      this.endTime = endTime
      this.value = null
      if (value == 30) {
        this.titleHeader = '近30天'
        this.isChange = value
      } else if (value == 7) {
        this.titleHeader = '近七天'
        this.isChange = value
      } else {
        this.titleHeader = '昨日'
        this.isChange = value
      }
      this.getMemberOverviewData()
      this.getLogUtils().logWithTag('startDate', this.startTime)
      this.getLogUtils().logWithTag('endDate', this.endTime)
    },
    //获取用户实时数据
    getMemberRealTime() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantMemberStatisticRealTime', {
        specificDay: this.todayTime
      }).then(res => {
        this.todayData = res
        this.getLogUtils().logWithTag('用户实时数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取用户总览数据
    getMemberOverviewData() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantMemberOverviewData', {
        endDay: this.endTime,
        startDay: this.startTime
      }).then(res => {
        this.overviewData = res
        this.lineData = res.itemList
        this.getLogUtils().logWithTag('用户概览数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
.isActive {
  color: #40a9ff;
}

.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  border-left: 1px solid cornflowerblue;
}

.row-style {
  padding: 20px;
  border-radius: 3px;
  margin: 15px 0;
  border: 1px solid #d5d5d5;
}

.line-title {
  margin: 50px 0 20px 10px;
  font-size: 14px;;
}

.right-title {
  position: absolute;
  right: 20px;
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}
</style>
